<template>
    <header>
        <LogoBar :loading="loading" :data="data" />
        <HeaderMenu :loading="loading" :data="data" class="d-none d-md-block" />
    </header>
</template>

<script>
    import LogoBar from './type4/LogoBar';
    import HeaderMenu from './type4/HeaderMenu';

    import { mapGetters } from 'vuex';

    export default {
        data: () => ({
            header_type: '',
            loading: true,
            data: {},
        }),
        components: {
            // TopBar,
            LogoBar,
            HeaderMenu,
        },
        computed: {
            ...mapGetters('app', ['generalSettings']),
        },
        methods: {
            async getDetails() {
                const res = await this.call_api('get', `setting/header`);
                if (res.status === 200) {
                    this.data = res.data;
                    this.header_type = res.data.header_type;
                    this.loading = false;
                }
            },
        },
        created() {
            this.getDetails();
        },
    };
</script>
<style lang="scss" scoped>
    .header-sticky {
        z-index: 101;
    }
</style>
